module.exports = __webpack_public_path__ + "img/canbadge-round-76mm-asa_comp_line.b55e524e.png";